import { ReplaceProductsTable } from './replace-products-table';

export { ReplaceProductsTable };
